import React, { useEffect, useState } from 'react'
import { FaMoon, FaSun } from 'react-icons/fa'
import { burstConfetti } from '../utils'

const KONAMI = ['ArrowUp','ArrowUp','ArrowDown','ArrowDown','ArrowLeft','ArrowRight','ArrowLeft','ArrowRight','b','a']

// Dark-mode toggle, palette launcher, and a Konami-code easter egg.
function FloatingControls() {
  const [theme, setTheme] = useState(() => {
    try { return localStorage.getItem('theme') || 'light' } catch (e) { return 'light' }
  })

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme)
    try { localStorage.setItem('theme', theme) } catch (e) {}
  }, [theme])

  useEffect(() => {
    const toggle = () => setTheme(t => (t === 'dark' ? 'light' : 'dark'))
    let seq = []
    const onKey = e => {
      seq = [...seq, e.key].slice(-KONAMI.length)
      if (seq.join() === KONAMI.join()) burstConfetti(window.innerWidth / 2, window.innerHeight / 3, 140)
    }
    window.addEventListener('toggle-theme', toggle)
    window.addEventListener('keydown', onKey)
    return () => {
      window.removeEventListener('toggle-theme', toggle)
      window.removeEventListener('keydown', onKey)
    }
  }, [])

  return (
    <div className="floating-controls">
      <button onClick={() => window.dispatchEvent(new Event('open-palette'))} aria-label="Open command palette" title="Command palette (Ctrl/⌘ + K)">
        <kbd>⌘K</kbd>
      </button>
      <button onClick={() => setTheme(t => (t === 'dark' ? 'light' : 'dark'))} aria-label="Toggle dark mode" title="Toggle theme">
        {theme === 'dark' ? <FaSun /> : <FaMoon />}
      </button>
    </div>
  )
}

export default FloatingControls
